<template>
  <div class="adminprogramme">
    <div class="header">
      <div class="title">解决方案提供</div>
      <div class="border"></div>
    </div>

    <div>
      <div class="body">
        <div class="left">
          <img :src="adminprogramme2" alt="" />
        </div>
        <div class="right">
          <div class="title">打破硬件孤岛 实现软硬一体化</div>
          <div class="text">
            汇集社区实时动态视频，进行结构化分析并存储；通过小区出入口及内部摄像机采集小区人脸、车牌、周界视频、充电桩状态检测等形成视频结构化数据
          </div>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="body1">
        <div class="left">
          <div class="title">多个社区共同管理 直观清晰</div>
          <div class="text">
            通过前端智能感知硬件：智能无人门岗、人脸识别、车辆识别、周界报警等，结合人工智能，AI算法的预警交互到管控平台和责任人，实现现代智能化物业管理的一种新型物管模式
          </div>
        </div>
        <div class="right">
          <img :src="adminprogramme1" alt="" />
        </div>
      </div>
    </div>

    <div style="margin-bottom: 80px">
      <div class="body">
        <div class="left">
          <img :src="adminprogramme3" alt="" />
        </div>
        <div class="right">
          <div class="title">自动生成报表 提高财务工作效率</div>
          <div class="text">
            报表样式自定义调节，多种票据开具以及统计管理，票据状态动态变更，支持财务按收付实现制和权责发生制。自动生成财务对账单，月底结算对账更轻松
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import adminprogramme1 from "../../../../assets/programme/adminprogramme1.png";
import adminprogramme2 from "../../../../assets/programme/adminprogramme2.png";
import adminprogramme3 from "../../../../assets/programme/adminprogramme3.png";

export default {
  setup() {
    return reactive({
      adminprogramme1: adminprogramme1,
      adminprogramme2: adminprogramme2,
      adminprogramme3: adminprogramme3,
    });
  },
};
</script>

<style scoped>
.adminprogramme {
  margin: 0 auto 0;
}
.header {
  width: 1180px;
  margin: 0 auto 40px;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto;
}
@media screen and (max-width: 1180px) {
  .box {
    min-width: 1180px;
  }
}
.box {
  background: linear-gradient(180deg, #eff7ff 0%, #fdfeff 100%);
  box-shadow: inset 0px 10px 20px 1px rgba(31, 81, 210, 0.06);
  padding: 110px 0;
  margin: 80px 0;
}
.body {
  width: 1108px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.body .left img {
  width: 457px;
}
.body .right {
  width: 500px;
}
.body .right .title {
  font-size: 16px;
  color: #333;
}
.body .right .text {
  font-size: 14px;
  margin-top: 20px;
  color: #495a6c;
}

.body1 {
  width: 1108px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.body1 .right img {
  width: 457px;
}
.body1 .left {
  width: 500px;
}
.body1 .left .title {
  font-size: 16px;
  color: #333;
}
.body1 .left .text {
  font-size: 14px;
  margin-top: 20px;
  color: #495a6c;
}
</style>
